import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { ContentArea } from '../../../common/components/Content'
import Account from './Account'
import Plans from './Plans'
import SettingsSidebar from './SettingsSidebar'
import { connect } from 'react-redux'
import { smallScreenSelector } from '../../store/selectors/boardSelectors'

const Settings = ({ smallScreen }) => {
  return (
    <>
      {/* On large screen always show sidebar */}
      {!smallScreen && <SettingsSidebar />}

      {/* at /settings either show sidebar or redirect to /settings/account  */}
      <Route
        path="/settings"
        exact
        render={() =>
          smallScreen ? (
            <SettingsSidebar />
          ) : (
            <Redirect to="/settings/account" />
          )
        }
      />

      <ContentArea>
        <Route path="/settings/account" component={Account} />
        <Route path="/settings/plan" component={Plans} />
      </ContentArea>
    </>
  )
}

export default connect(state => ({ smallScreen: smallScreenSelector(state) }))(
  Settings
)
